export default __webpack_public_path__ + "static/media/logo-dark.e8a5a9b3.svg";